import React from 'react';
import './GeneralProfileChatFlow.css';

export interface ProfileUserAnswerRowProps {
  children: React.ReactNode;
  showUndo?: boolean;
  onUndo?: () => void;
  showEdit?: boolean;
  onEdit?: () => void;
  undoLabel: string;
  editLabel?: string;
}

const ProfileUserAnswerRow: React.FC<ProfileUserAnswerRowProps> = ({
  children,
  showUndo,
  onUndo,
  showEdit,
  onEdit,
  undoLabel,
  editLabel,
}) => (
  <div className="gen-profile-chat__row gen-profile-chat__row--user gen-profile-chat__row--enter">
    <div className="gen-profile-chat__user-bubble-wrap">
      <div className="gen-profile-chat__bubble gen-profile-chat__bubble--user">
        <div className="gen-profile-chat__user-lines">{children}</div>
      </div>
      {showEdit && onEdit && (
        <button
          type="button"
          className="gen-profile-chat__edit"
          onClick={onEdit}
          aria-label={editLabel}
        >
          {editLabel}
        </button>
      )}
      {showUndo && onUndo && (
        <button type="button" className="gen-profile-chat__undo" onClick={onUndo}>
          {undoLabel}
        </button>
      )}
    </div>
  </div>
);

export default ProfileUserAnswerRow;
